export const BillingAccountIdRegex = /^[A-Z0-9]{6}-[A-Z0-9]{6}-[A-Z0-9]{6}$/;

export const BillingAccountIdRegexError = {
  InvalidFormat: "Invalid Billing Account ID format.",
  AlreadyExists: "Billing Account is already connected to DoiT Console.",
};
